module.exports = __webpack_public_path__ + "img/reaction6.740e69e7.png";